module.exports = __webpack_public_path__ + "a364a3a1e50494aa9a4854ef88676556.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-30.png
// module id = 2057
// module chunks = 0